import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  CellContent
} from "../../styled-components/Table";
import Constants from "../../constants/deliveryStatusTable";
import LuciPropTypes from "../../propTypes/";
import Settings from "../../settings";
import { localizeAxis as localize } from "../../util/localizeUtils";

const debug = process.env.NODE_ENV === "development";

const PreviewLink = styled.a`
  text-decoration: underline;
`;

class DeliveryStatusTable extends Component {
  render() {
    const deliveryStatusRows = this.props.deliveryFeed.map(feed => {
      const previewUrl =
        feed.previewUrl && debug
          ? feed.previewUrl.replace("../", Settings.camioServer)
          : feed.previewUrl;

      return (
        <TableRow flash flashColor="#FFA523" flashDuration="3s" key={feed.id}>
          <TableCell width={Constants.DELIVERY_STATUS_COLUMN_WIDTH}>
            <CellContent>
              {`${feed.assetType} "${feed.assetTitle}" ${
                feed.displayId ? `(${feed.displayId})` : ""
              } is `}
              <em>{feed.status}</em>
            </CellContent>
          </TableCell>
          <TableCell width={Constants.MAPS_COLUMN_WIDTH}>
            ({feed.date})
          </TableCell>
          <TableCell width={Constants.ORDER_COLUMN_WIDTH}>
            <PreviewLink href={previewUrl} target="_blank">
              {localize("previewLink")}
            </PreviewLink>
          </TableCell>
        </TableRow>
      );
    });
    return (
      <Table fontSize="11px" width="100%">
        <TableBody overflowY="scroll">{deliveryStatusRows}</TableBody>
      </Table>
    );
  }
}

DeliveryStatusTable.defaultProps = {
  deliveryFeed: []
};

DeliveryStatusTable.propTypes = {
  deliveryFeed: PropTypes.arrayOf(LuciPropTypes.AxisDeliveryFeed)
};

export default DeliveryStatusTable;



// WEBPACK FOOTER //
// ./app/components/DeliveryStatus/DeliveryStatusTable.js